<template>
  <!-- Sidebar - Desktop only -->
  <aside class="bg-white border-r border-neutral-100 w-64 min-h-screen">

    <nav class="p-4 pt-8 flex flex-col gap-2">
      <RouterLink 
        v-for="item in menuItems"
        :key="item.path"
        :to="item.path"
        class="flex items-center gap-3 px-4 py-3 rounded-lg-custom font-bold text-sm transition-colors"
        :class="isActive(item.path) ? 'bg-neutral-50 text-neutral-950' : 'text-neutral-600 hover:bg-neutral-50'"
      >
        <component :is="item.icon" class="w-5 h-5" />
        {{ item.label }}
      </RouterLink>
    </nav>
  </aside>
</template>

<script>
import { RouterLink } from 'vue-router';
import { h } from 'vue';

// Icon components z Figmy
const LevelIcon = () => h('svg', {
  viewBox: '0 0 20 20', 
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
  stroke: 'currentColor',
  'stroke-width': '1.5'
}, [
  h('path', { 
    d: 'M5.83334 15V11.6667',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round'
  }),
  h('path', { 
    d: 'M10 15V8.33333',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round'
  }),
  h('path', { 
    d: 'M14.1667 15V5',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round'
  })
]);


const PathsIcon = () => h('svg', {
  xmlns: 'http://www.w3.org/2000/svg',
  fill: 'none',
  viewBox: '0 0 24 24',
  stroke: 'currentColor',
  'stroke-width': '1.5'
}, [
  h('path', {
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    d: 'M9 9V4.5M9 9H4.5M9 9 3.75 3.75M9 15v4.5M9 15H4.5M9 15l-5.25 5.25M15 9h4.5M15 9V4.5M15 9l5.25-5.25M15 15h4.5M15 15v4.5m0-4.5 5.25 5.25'
  })
]);


const UserIcon = () => h('svg', {
  viewBox: '0 0 20 20', 
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
  stroke: 'currentColor',
  'stroke-width': '1.5'
}, [
  h('path', { 
    d: 'M10.0001 9.99999C12.3013 9.99999 14.1667 8.13451 14.1667 5.83332C14.1667 3.53214 12.3013 1.66666 10.0001 1.66666C7.69889 1.66666 5.83341 3.53214 5.83341 5.83332C5.83341 8.13451 7.69889 9.99999 10.0001 9.99999Z',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round'
  }),
  h('path', { 
    d: 'M17.1583 18.3333C17.1583 15.1083 13.95 12.5 10 12.5C6.04996 12.5 2.84164 15.1083 2.84164 18.3333',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round'
  })
]);

const OrdersIcon = () => h('svg', {
  viewBox: '0 0 20 20', 
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
  stroke: 'currentColor',
  'stroke-width': '1.5'
}, [
  h('path', { 
    d: 'M6.66667 1.66667V4.16667',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round'
  }),
  h('path', { 
    d: 'M13.3333 1.66667V4.16667',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round'
  }),
  h('path', { 
    d: 'M2.91667 7.57583H17.0833',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round'
  }),
  h('path', { 
    d: 'M17.5 7.08333V14.1667C17.5 16.6667 16.25 18.3333 13.3333 18.3333H6.66667C3.75 18.3333 2.5 16.6667 2.5 14.1667V7.08333C2.5 4.58333 3.75 2.91667 6.66667 2.91667H13.3333C16.25 2.91667 17.5 4.58333 17.5 7.08333Z',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round'
  })
]);

const UnsubscribeIcon = () => h('svg', {
  xmlns: 'http://www.w3.org/2000/svg',
  fill: 'none',
  viewBox: '0 0 24 24',
  stroke: 'currentColor',
  'stroke-width': '1.5'
}, [
  h('path', {
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    d: 'M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0M3.124 7.5A8.969 8.969 0 0 1 5.292 3m13.416 0a8.969 8.969 0 0 1 2.168 4.5'
  })
]);

const AgreementIcon = () => h('svg', {
  xmlns: 'http://www.w3.org/2000/svg',
  fill: 'none',
  viewBox: '0 0 24 24',
  stroke: 'currentColor',
  'stroke-width': '1.5'
}, [
  h('path', {
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    d: 'M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z'
  })
]);



const AcademicCapIcon = () => h('svg', {
  xmlns: 'http://www.w3.org/2000/svg',
  fill: 'none',
  viewBox: '0 0 24 24',
  stroke: 'currentColor',
  'stroke-width': '1.5'
}, [
  h('path', {
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    d: 'M4.26 10.147a60.438 60.438 0 0 0-.491 6.347A48.62 48.62 0 0 1 12 20.904a48.62 48.62 0 0 1 8.232-4.41 60.46 60.46 0 0 0-.491-6.347m-15.482 0a50.636 50.636 0 0 0-2.658-.813A59.906 59.906 0 0 1 12 3.493a59.903 59.903 0 0 1 10.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.717 50.717 0 0 1 12 13.489a50.702 50.702 0 0 1 7.74-3.342M6.75 15a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm0 0v-3.675A55.378 55.378 0 0 1 12 8.443m-7.007 11.55A5.981 5.981 0 0 0 6.75 15.75v-1.5'
  })
]);



const menuItems = [
   {
    path: '/customer/courses',
    label: 'Dla Ciebie',
    icon: AcademicCapIcon
  },
  {
    path: '/customer/level',
    label: 'Ścieżki rozwoju',
    icon: PathsIcon
  },
  {
    path: '/customer/profile',
    label: 'Moje dane',
    icon: UserIcon
  },
  {
    path: '/customer/orders',
    label: 'Zamówienia',
    icon: OrdersIcon
  },
  {
    path: '/customer/unsubscribe',
    label: 'Zgody',
    icon: AgreementIcon
  }
];

export default {
  name: 'CustomerSidebar',
  components: {
    RouterLink,
  },
  props: {
    mobileOpen: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close'],
  data() {
    return {
      menuItems,
    };
  },
  methods: {
    isActive(path) {
      return (
        this.$route.path === path
      );
    },
  },
};
</script>

